import React from 'react';
import Footer from "../shared/components/Footer";
import NavBar from "../shared/components/Navbar";
import HeroSection from "./components/HeroSection";
import ValueSection from "./components/ValueSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import TestimonialsSection from "./components/TestimonialsSection";
import PricingSection from "./components/PricingSection";
import FAQSection from "./components/FAQSection";
import LandingBlogSection from "./components/LandingBlogSection";

function Home() {
    return (
        <div className="font-sans bg-white min-h-screen flex flex-col overflow-hidden">
            <NavBar />
            <HeroSection />
            <ValueSection />
            <FeaturesSection />
            <LandingBlogSection />
            {/* <HowItWorksSection /> */}
            {/* <TestimonialsSection /> */}
            <PricingSection />
            <FAQSection />
            <Footer />
        </div>
    );
}

export default Home;